module.exports = __webpack_public_path__ + "static/media/Discovery_Kids_Museum_undersea_mural_detail_6_Huntersville_NC_2012.3940e058.webp";